import { FAQ_LIST, FAQ_EDIT } from "../constants/api-path";
import httpClient from "./http.interceptor";

/**
 * List FAQs
 * @param {object} params - { page, limit, sort, search }
 * @returns Promise<any>
 */
export const getFaqList = (params: any): Promise<any> => {
  return httpClient.get(FAQ_LIST, {
    params: {
      page: params.page,
      pageSize: params.limit,
      sort: params.sort,
      search: params.search,
      status: params.status,
    },
  });
};

/**
 * Get FAQ by ID
 * @param {string|number} id
 * @returns Promise<any>
 */
export const getFaqById = (id: string | number): Promise<any> => {
  return httpClient.get(`${FAQ_EDIT}${id}`);
};

/**
 * Add FAQ
 * @param {object} data
 * @returns Promise<any>
 */
export const addFaq = (data: any): Promise<any> => {
  return httpClient.post(FAQ_LIST, data);
};

/**
 * Update FAQ
 * @param {string|number} id
 * @param {object} data
 * @returns Promise<any>
 */
export const updateFaq = (id: string | number, data: any): Promise<any> => {
  return httpClient.put(`${FAQ_EDIT}${id}`, data);
};

/**
 * Delete FAQ
 * @param {string|number} id
 * @returns Promise<any>
 */
export const deleteFaq = (id: string | number): Promise<any> => {
  return httpClient.delete(`${FAQ_EDIT}${id}`);
};
